import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SubscriptionPlanRecapComponent } from '~app/app/subscription/components/subscription-plan-recap/subscription-plan-recap.component';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';

@Component({
  selector: 'competing-ads-creation-dialog',
  standalone: true,
  imports: [],
  templateUrl: './competing-ads-creation-dialog.component.html',
  styleUrl: './competing-ads-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetingAdsCreationDialogComponent extends BaseComponent {
  protected _dialogRef = inject(MatDialogRef<SubscriptionPlanRecapComponent>);
  close(): void {
    this._dialogRef.close();
  }
}
